import * as React from 'react';
import {Component} from 'react';
import cx from 'classnames';
import {Dropdown, IconTrigger} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {withUpdate} from '../../../../components/Common/HOC/withUpdate';
import {MenuIcon} from './MenuIcon';
import {MenuItem} from './MenuItem';
import {PageSettings} from './PageSettings';
import {actionsToMonitor} from '../../consts/headerConsts';
import {sendMonitor} from '../../../../utils/monitoring';
import {AppSearches} from '../../../../features/AppSearches';
import {Tooltip} from '../../../../components/Common/Tooltip/index';
import styles from '../../style/Submenu.module.scss';

class LowerMenuComp extends Component<
    {lowerMenu; topMenu; funcs; setUpdateFunc; isPopupView; isRTL},
    any
> {
    renderShareButton = () => {
        const {lowerMenu, funcs, isRTL} = this.props;
        const {shareButton} = lowerMenu;
        const {options, tooltip} = shareButton;

        const handleItemClick = item => {
            item.action && item.action(item.command);
            if (actionsToMonitor.includes(item.cmdID)) {
                sendMonitor(`share item click - ${item.title}`);
            }
        };
        return (
            <Dropdown
                trigger={
                    <Tooltip tooltip={tooltip} position="bottom center">
                        <IconTrigger
                            icon="new_export"
                            className={cx(styles.shareTrigger, styles.newPadding)}
                            disabled={shareButton.isDisabled()}
                        />
                    </Tooltip>
                }
                onClose={funcs.focus}
                openingSide="leftSide"
            >
                <Dropdown.Content width={240}>
                    <Dropdown.Header
                        title={getLocalizedText(texts.shareRecord)}
                        componentClasses="dropdown-menu-header"
                    />
                    {options &&
                        options.map((item, index) => {
                            return (
                                <Dropdown.Item
                                    key={index}
                                    onClick={() => handleItemClick(item)}
                                    index={index}
                                    divider={index !== options.length - 1}
                                    componentClasses={'menu-item'}
                                >
                                    <MenuItem
                                        title={item.title}
                                        shortkey={item.shortKey}
                                        tooltip={item.desc}
                                        position={isRTL ? 'right center' : 'left center'}
                                        tooltipClassname="side-tooltip"
                                        delay={1000}
                                    />
                                </Dropdown.Item>
                            );
                        })}
                </Dropdown.Content>
            </Dropdown>
        );
    };

    renderPageSettings = () => {
        const {isPopupView} = this.props;

        if (isPopupView && isPopupView()) {
            return <PageSettings {...this.props} isPopup />;
        }

        return null;
    };

    render() {
        const {lowerMenu, isRTL} = this.props;
        const {undoButton, deleteButton, flagButton} = lowerMenu;

        /** TODO: we need to handle this issue in a more generic way */
        const tooltipPosition = isRTL ? 'bottom left' : 'bottom right';
        return (
            <>
                <AppSearches />
                <section className="buttons-section">
                    <div className="buttons-row">
                        <MenuIcon name="undo-icon" item={undoButton} primarySkin />
                        <MenuIcon name="delete-icon" item={deleteButton} primarySkin />
                        {this.renderShareButton()}
                        {this.renderPageSettings()}
                        <MenuIcon
                            name="flag-icon"
                            item={flagButton}
                            tooltipPosition={tooltipPosition}
                            primarySkin
                        />
                    </div>
                </section>
            </>
        );
    }
}

export const LowerMenu = withUpdate(LowerMenuComp);
